const NAMESPACE = 'PRESETS' as const;

const RECENTS_MODAL_IDENTIFIER = `${NAMESPACE}/recentsModal` as const;

const PRESET_KINDS = Object.freeze({
  RECENT: 'recent',
} as const);

const LAST_ACCESS_TIME_FORMAT = 'MMM do yyyy' as const;

const DEFAULT_TUNNEL_NAME = 'default' as const;

const MAX_RECENTS_ITEMS = 10 as const;

export default {
  DEFAULT_TUNNEL_NAME,
  LAST_ACCESS_TIME_FORMAT,
  MAX_RECENTS_ITEMS,
  NAMESPACE,
  PRESET_KINDS,
  RECENTS_MODAL_IDENTIFIER,
};
